// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"117":"fa7c16ce28a2d553","144":"90f4e3b20fb0dfb8","387":"f89c471ccd86669c","471":"ab855bbd2c7f1f0c"}[chunkId] + ".js";
};